import React from "react";

import svg from "../../assets/images/icons/Text Merge Dark .svg";

export const TextMergeDarkIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Mapping"}
    />
);
